import { render } from "./ModalDocumentSendComplete.vue?vue&type=template&id=601e1195&scoped=true"
import script from "./ModalDocumentSendComplete.vue?vue&type=script&lang=js"
export * from "./ModalDocumentSendComplete.vue?vue&type=script&lang=js"

import "./ModalDocumentSendComplete.vue?vue&type=style&index=0&id=601e1195&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-601e1195"]])

export default __exports__